module.exports = __webpack_public_path__ + "static/button2-2ebce120c5e8f18d044ffe418282b51b.png";